/*
	Форма редактирования пользователя
*/
class FormEdit extends Form {
	maskCompleted = false;
	phoneRequired = false;

	constructor($form) {
		super($form);

		const
			$phone = this.$inputs.filter('[name="phone"]');

		this.phoneRequired = $phone.prop('required') || $phone.attr('required') !== undefined;

		if (this.phoneRequired) {
			$phone.on('maskCompleted', this.onMaskCompleted.bind(this));
			$phone.on('maskUncompleted', this.onMaskUncompleted.bind(this));
		}
	}

	//-------------------------------------------------
	//Запрос на активацию кнопки для возможности его отмены
	canEnableButton() {
		return this.phoneRequired ? this.maskCompleted : true;
	}

	//-------------------------------------------------
	//Событие завершения маски телефона
	onMaskCompleted() {
		this.maskCompleted = true;
		this.onInputReqChange();
	}

	//-------------------------------------------------
	//Событие отмены маски телефона
	onMaskUncompleted() {
		this.maskCompleted = false;
		this.onInputReqChange();
	}
}